import { Box, Container, Heading, Stack } from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';

import { responsive } from '../../contexts/responsive';
import NavHeading from '../NavHeading';
import WaitingListForm from './WaitingListForm'

export { query } from '../portalQuery';

const WaitingListPage = (props) => {
  return (
    <Container bg="white" px="0">
      <Box
        p="2"
        position={`sticky`}
        top="0"
        zIndex={`sticky`}
        bg="white"
        boxShadow={`md`}
    >
        <NavHeading data={props} />
      </Box>
      <Stack spacing={4} px={responsive(4, 6)} py={responsive(4, 8)}>
        <Heading as="h1" size="lg">【Portaly™ 傳送門】白名單</Heading>
        <Box height="1" bg="custom.primary" />
        <WaitingListForm profileId={props.id} profileName={props.name} profileSlug={props.slug} />
      </Stack>
    </Container>
  )
};

export default WaitingListPage;
